const checkItemByCinemaId = (item, cinemaId, cinemasAttr = 'cinemaIds') => {
    const cinemaIds = item[cinemasAttr]

    return cinemaIds && cinemaIds.includes(cinemaId)
}

export default checkItemByCinemaId
